export const getAllModulesIds = () => {
  const modules = import.meta.glob<true, any, any>(
    "../admin/modules/**/enabled.ts",
  );

  return Object.keys(modules).map((path) => {
    return path.split("/")[3];
  });
};
